var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("canvas", {
    staticStyle: { display: "block", margin: "0 auto" },
    attrs: { id: "filePreview" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }